module.exports = __webpack_public_path__ + "static/img/HanYuan_Banner_summer.87eaec91.jpg";